export default {
  header: 'Stappen',
  days: 'dagen',
};
